<template>
	<div
		class="g-block-pay-jumplink-course"
		:class="{
			'g-block-pay-jumplink-course--edit': editable,
			'is-active': editable && active,
			'g-block-pay-jumplink-course--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-pay-jumplink-course__card" :style="cardStyle">
			<div class="g-block-pay-jumplink-course__badge">
				<span class="g-block-pay-jumplink-course__badge-icon">
					<i class="mbm-iconfont mbm-sijiaoxing"></i>
				</span>
				<span>{{ data.badgeText || '实战进阶' }}</span>
			</div>
			<p class="g-block-pay-jumplink-course__title">{{ data.title || 'ChatGPT变现实战课' }}</p>
			<p class="g-block-pay-jumplink-course__subtitle">{{ data.subtitle || '支付后跳转进入课程详情页' }}</p>
			<div class="g-block-pay-jumplink-course__price-row" v-if="!isGeditModulePaid && !shouldHidePrice">
				<span class="g-block-pay-jumplink-course__promo">{{ data.promoTag || '限时特惠' }}</span>
				<span class="g-block-pay-jumplink-course__price">
					<span class="g-block-pay-jumplink-course__currency">¥</span>
					<span class="g-block-pay-jumplink-course__integer">{{ priceParts.integer }}</span>
					<span class="g-block-pay-jumplink-course__decimal">{{ priceParts.decimal }}</span>
				</span>
			</div>
			<div class="g-block-pay-jumplink-course__footer">
				<div class="g-block-pay-jumplink-course__features">
					<template v-for="(item, index) in displayFeatures" :key="index">
						<div class="g-block-pay-jumplink-course__feature">
							<span class="g-block-pay-jumplink-course__feature-icon-wrap">
								<img
									v-if="item.iconUrl"
									:src="item.iconUrl"
									class="g-block-pay-jumplink-course__feature-icon"
									alt=""
								/>
							</span>
							<div class="g-block-pay-jumplink-course__feature-text">
								<p class="g-block-pay-jumplink-course__feature-title">{{ item.title }}</p>
							</div>
						</div>
						<span
							v-if="index < displayFeatures.length - 1"
							class="g-block-pay-jumplink-course__feature-divider"
						></span>
					</template>
				</div>
				<div
					class="g-block-pay-jumplink-course__btn"
					@click.stop="onButtonClick"
				>
					<span>{{ (isGeditModulePaid ? data.unlockedButtonText : '') || data.buttonText || '立即学习' }}</span>
					<i class="mbm-iconfont mbm-youjiantou1"></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice } from '../shared/utils.js';
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import { resolveGeditDemoImageUrl } from '../../../utils/localAssets.js';
	import { DEFAULT_PAY_UNLOCK_JUMPLINK_COURSE } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockJumpLinkCourse',
		mixins: [payUnlockMixin],
		computed: {
			cardStyle() {
				const bg = this.resolveImageUrl(this.data.bgImage || DEFAULT_PAY_UNLOCK_JUMPLINK_COURSE.bgImage);
				return {
					backgroundImage: bg ? `url(${bg})` : 'none',
				};
			},
			priceParts() {
				const price = formatPayPrice(this.data.price ?? DEFAULT_PAY_UNLOCK_JUMPLINK_COURSE.price);
				const [integer, decimal = '00'] = price.split('.');
				return {
					integer,
					decimal: `.${decimal}`,
				};
			},
			displayFeatures() {
				const defaults = DEFAULT_PAY_UNLOCK_JUMPLINK_COURSE.features || [];
				const list = Array.isArray(this.data.features) && this.data.features.length
					? this.data.features
					: defaults;
				return list.map((item, index) => {
					const fallback = defaults[index] || {};
					return {
						title: item.title || fallback.title || '',
						subtitle: item.subtitle || fallback.subtitle || '',
						iconUrl: this.resolveImageUrl(item.icon || fallback.icon || ''),
					};
				});
			},
		},
		methods: {
			resolveImageUrl(url) {
				return resolveGeditDemoImageUrl(url);
			},
			onButtonClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.isGeditModulePaid) {
					this.doJump();
				} else {
					this.runModulePayFlow();
				}
			},
			doJump() {
				if (this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
					return;
				}
				const jumpUrl = this.data.jumpUrl;
				if (!jumpUrl) {
					console.warn('JumpLinkCourse: 未配置跳转链接');
					return;
				}
				window.location.href = jumpUrl;
			},
			runModulePayFlow() {
				if (this.editable) return;
				if (!this.isGeditRealPay) return;
				if (this.isGeditModulePaid) return;
				const oId = this.geditPayModuleId;
				if (!oId) return;
				const requestPay = this.geditPay?.requestPay;
				if (typeof requestPay !== 'function') return;
				Promise.resolve(requestPay(oId)).catch(() => {});
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-pay-jumplink-course {
		/* 公共：结构与颜色，不含尺寸 */
		&--edit {
			border: 1px solid transparent;
			border-radius: 16px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

		&__card {
			position: relative;
			overflow: hidden;
			background-size: cover;
			background-position: center right;
			background-repeat: no-repeat;
			color: #fff;
		}

		&__badge {
			display: inline-flex;
			align-items: center;
			border-radius: 999px;
			background: #e3ebf7;
			border: 1px solid rgba(255, 255, 255, 0.18);
			color: #253349;
			line-height: 1.2;
		}

		&__badge-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			.mbm-iconfont {
				color: #0785ff;
			}
		}

		&__title {
			margin: 0;
			font-weight: 700;
			line-height: 1.3;
			color: #233143;
		}

		&__subtitle {
			margin: 0;
			line-height: 1.4;
			color: #6e7991;
		}

		&__price-row {
			display: flex;
			align-items: flex-end;
		}

		&__promo {
			display: inline-flex;
			align-items: center;
			border-radius: 4px;
			color: #2c78fa;
			border: none;
			background: #e3ebf7;
			line-height: 1.2;
		}

		&__price {
			display: inline-flex;
			align-items: flex-end;
			font-weight: 700;
			line-height: 1;
		}

		&__currency,
		&__integer,
		&__decimal {
			color: #2c78fa;
			-webkit-background-clip: text;
			background-clip: text;
		}

		&__footer {
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #edf0f7;
			border: 1px solid #d3e3fa;
		}

		&__features {
			display: flex;
			align-items: center;
			justify-content: space-between;
			min-width: 0;
			flex: 1;
		}

		&__feature {
			display: flex;
			align-items: center;
			min-width: 0;
		}

		&__feature-divider {
			flex-shrink: 0;
			align-self: stretch;
			width: 1px;
			margin: 2px 0;
			background: rgba(255, 255, 255, .1);
		}

		&__feature-icon-wrap {
			flex-shrink: 0;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			border-radius: 34%;
			background: rgba(255, 255, 255, 0.1);
		}

		&__feature-icon {
			display: block;
			object-fit: contain;
		}

		&__feature-text {
			min-width: 0;
		}

		&__feature-title {
			margin: 0;
			font-weight: 600;
			color: #233143;
			white-space: nowrap;
		}

		&__feature-sub {
			margin: 0;
			color: rgba(255, 255, 255, 0.55);
			white-space: nowrap;
		}

		&__btn {
			flex-shrink: 0;
			display: inline-flex;
			align-items: center;
			background: rgb(36, 97, 255);
			color: #fff;
			font-weight: 600;
			line-height: 1;
			cursor: pointer;
			user-select: none;
		}

		/* ========== 左侧组件库预览（无 --edit / --h5，窄宽度紧凑） ========== */
		&:not(&--edit):not(&--h5) {
			.g-block-pay-jumplink-course__card {
				border-radius: 12px;
				padding: 14px 12px 10px;
				box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
			}

			.g-block-pay-jumplink-course__badge {
				gap: 4px;
				padding: 3px 8px 3px 3px;
				font-size: 12px;
			}

			.g-block-pay-jumplink-course__badge-icon {
				width: 16px;
				height: 16px;

				.mbm-iconfont {
					font-size: 14px;
				}
			}

			.g-block-pay-jumplink-course__title {
				margin-top: 10px;
				font-size: 16px;
			}

			.g-block-pay-jumplink-course__subtitle {
				margin-top: 6px;
				font-size: 11px;
			}

			.g-block-pay-jumplink-course__price-row {
				gap: 6px;
				margin: 12px 0 0px;
			}

			.g-block-pay-jumplink-course__promo {
				padding: 2px 6px;
				font-size: 10px;
				margin-bottom: 4px;
			}

			.g-block-pay-jumplink-course__currency {
				font-size: 23px;
				margin-right: 1px;
				margin-top: 6px;
			}

			.g-block-pay-jumplink-course__integer {
				font-size: 38px;
			}

			.g-block-pay-jumplink-course__decimal {
				font-size: 23px;
				margin-top: 4px;
			}

			.g-block-pay-jumplink-course__footer {
				gap: 10px;
				padding: 8px 12px 8px 10px;
				border-radius: 8px;
				margin-top: 16px;
			}

			.g-block-pay-jumplink-course__features {
				justify-content: space-between;
				gap: 0;
			}

			.g-block-pay-jumplink-course__feature {
				gap: 3px;
			}

			.g-block-pay-jumplink-course__feature-icon-wrap {
				width: 20px;
				height: 20px;
			}

			.g-block-pay-jumplink-course__feature-icon {
				width: 15px;
				height: 15px;
			}

			.g-block-pay-jumplink-course__feature-title {
				font-size: 9px;
				line-height: 1.15;
			}

			.g-block-pay-jumplink-course__feature-sub {
				margin-top: 1px;
				font-size: 9px;
				line-height: 1.15;
			}

			.g-block-pay-jumplink-course__btn {
				gap: 2px;
				padding: 8px 10px;
				border-radius: 8px;
				font-size: 11px;

				.mbm-iconfont {
					font-size: 10px;
				}
			}
		}

		/* ========== 中间编辑区（--edit） ========== */
		&--edit {
			.g-block-pay-jumplink-course__card {
				border-radius: 16px;
				padding: 15px 13px 10px;
				box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
			}

			.g-block-pay-jumplink-course__badge {
				gap: 4px;
				padding: 4px 12px 4px 4px;
				font-size: 12px;
			}

			.g-block-pay-jumplink-course__badge-icon {
				width: 20px;
				height: 20px;

				.mbm-iconfont {
					font-size: 15px;
				}
			}

			.g-block-pay-jumplink-course__title {
				margin-top: 14px;
				font-size: 24px;
			}

			.g-block-pay-jumplink-course__subtitle {
				margin-top: 8px;
				font-size: 13px;
			}

			.g-block-pay-jumplink-course__price-row {
				gap: 10px;
				margin: 18px 0 0px;
			}

			.g-block-pay-jumplink-course__promo {
				padding: 3px 8px;
				font-size: 12px;
				margin-bottom: 6px;
			}

			.g-block-pay-jumplink-course__currency {
				font-size: 26px;
				margin-right: 2px;
				margin-top: 10px;
			}

			.g-block-pay-jumplink-course__integer {
				font-size: 50px;
			}

			.g-block-pay-jumplink-course__decimal {
				font-size: 26px;
				margin-top: 6px;
			}

			.g-block-pay-jumplink-course__footer {
				gap: 20px;
				padding: 10px 16px 10px 12px;
				border-radius: 12px;
				margin-top: 16px;
			}

			.g-block-pay-jumplink-course__features {
				justify-content: space-between;
				gap: 0;
			}

			.g-block-pay-jumplink-course__feature {
				gap: 6px;
			}

			.g-block-pay-jumplink-course__feature-icon-wrap {
				width: 30px;
				height: 30px;
			}

			.g-block-pay-jumplink-course__feature-icon {
				width: 22px;
				height: 22px;
			}

			.g-block-pay-jumplink-course__feature-title {
				font-size: 12px;
				line-height: 1.2;
			}

			.g-block-pay-jumplink-course__feature-sub {
				margin-top: 2px;
				font-size: 12px;
				line-height: 1.2;
			}

			.g-block-pay-jumplink-course__btn {
				gap: 4px;
				padding: 10px 10px;
				border-radius: 10px;
				font-size: 14px;

				.mbm-iconfont {
					font-size: 12px;
				}
			}
		}

		/* ========== H5 ========== */
		&--h5 {
			.g-block-pay-jumplink-course__card {
				border-radius: 0.32rem;
				padding: 0.28rem 0.24rem 0.2rem;
				box-shadow: 0 0 0.32rem rgba(0, 0, 0, 0.1);
			}

			.g-block-pay-jumplink-course__badge {
				gap: 0.12rem;
				padding: 0.08rem 0.24rem 0.08rem 0.08rem;
				font-size: 0.24rem;
			}

			.g-block-pay-jumplink-course__badge-icon {
				width: 0.4rem;
				height: 0.4rem;

				.mbm-iconfont {
					font-size: 0.28rem;
				}
			}

			.g-block-pay-jumplink-course__title {
				margin-top: 0.28rem;
				font-size: 0.48rem;
			}

			.g-block-pay-jumplink-course__subtitle {
				margin-top: 0.16rem;
				font-size: 0.26rem;
			}

			.g-block-pay-jumplink-course__price-row {
				gap: 0.2rem;
				margin: 0.36rem 0 0;
			}

			.g-block-pay-jumplink-course__promo {
				padding: 0.04rem 0.12rem;
				font-size: 0.2rem;
				margin-bottom: 0.08rem;
			}

			.g-block-pay-jumplink-course__currency {
				font-size: 0.46rem;
				margin-right: 0.04rem;
				margin-top: 0.12rem;
			}

			.g-block-pay-jumplink-course__integer {
				font-size: 0.76rem;
			}

			.g-block-pay-jumplink-course__decimal {
				font-size: 0.46rem;
				margin-top: 0.12rem;
			}

			.g-block-pay-jumplink-course__footer {
				gap: 0.2rem;
				padding: 0.18rem 0.2rem 0.18rem 0.2rem;
				border-radius: 0.16rem;
				margin-top: 0.32rem;
			}

			.g-block-pay-jumplink-course__features {
				justify-content: space-between;
				gap: 0;
			}

			.g-block-pay-jumplink-course__feature {
				gap: 0.06rem;
			}

			.g-block-pay-jumplink-course__feature-icon-wrap {
				width: 0.44rem;
				height: 0.44rem;
			}

			.g-block-pay-jumplink-course__feature-icon {
				width: 0.30rem;
				height: 0.3rem;
			}

			.g-block-pay-jumplink-course__feature-title {
				font-size: 0.18rem;
				line-height: 1.15;
			}

			.g-block-pay-jumplink-course__feature-sub {
				margin-top: 0.02rem;
				font-size: 0.18rem;
				line-height: 1.15;
			}

			.g-block-pay-jumplink-course__btn {
				gap: 0.06rem;
				padding: 0.16rem 0.2rem;
				border-radius: 0.16rem;
				font-size: 0.22rem;

				.mbm-iconfont {
					font-size: 0.22rem;
				}
			}
		}
	}
</style>
